import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LuciTableComponent } from './luci-table.component';
import { LuciTooltipsModule } from '../luci-tooltips/luci-tooltips.module';
import { LuciDropdownModule } from '../luci-dropdown/luci-dropdown.module';
import { LuciPaginationModule } from '../luci-pagination/luci-pagination.module';
import { FormsModule } from '@angular/forms';

import { LuciSearchModule } from '../luci-search/luci-search.module';
import {ColumnFilterModule} from '../commons/pipes/column-filter/column-filter.module';
import {TreeFilterPipeModule} from '../commons/pipes/tree-filter-pipe/tree-filter-pipe.module';
import {SearchFilterPipeModule} from '../commons/pipes/search-filter/search-filter.pipe.module';
import {ResizeModule} from '../commons/directives/resize/resize.module';
import {LuciToolbarModule} from '../luci-toolbar/luci-toolbar.module';
import {GlobalSearchFilterModule} from '../commons/pipes/global-search-filter/global-search-filter.module';
import { NgDragDropModule } from 'ng-drag-drop';
import {ColumnFreezeFilterModule} from '../commons/pipes/column-freeze-filter/column-freeze-filter.module';
import {LuciBadgesModule} from '../luci-badges/luci-badges.module';
import {LuciButtonModule} from '../luci-button/luci-button.module';
import {LuciPersonalizationTableColumnsModule} from '../luci-personalization-table-columns/luci-personalization-table-columns.module';
import {LuciTableMultiColumnSortingModule} from '../luci-table-multi-column-sorting/luci-table-multi-column-sorting.module';

@NgModule({
  declarations: [LuciTableComponent],
  exports: [LuciTableComponent],
  imports: [
    CommonModule,
    LuciTooltipsModule,
    LuciDropdownModule,
    LuciPaginationModule,
    FormsModule,
    ResizeModule,
    SearchFilterPipeModule,
    TreeFilterPipeModule,
    ColumnFilterModule,
    LuciSearchModule,
    LuciButtonModule,
    LuciToolbarModule,
    GlobalSearchFilterModule,
    NgDragDropModule.forRoot(),
    ColumnFreezeFilterModule,
    LuciBadgesModule,
    LuciButtonModule,
    LuciPersonalizationTableColumnsModule,
    LuciTableMultiColumnSortingModule
  ]
})
export class LuciTableModule { }
